import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";
// tslint:disable
export const yammer_praise_ace: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 150 150" id="yk-svg-praise-ace" {...rest}>
      <title>praise-ace</title>
      <ellipse
        transform="rotate(-88.267 74.997 75.003) scale(.99996)"
        fill="#84CA4B"
        cx="75"
        cy="75"
        rx="75"
        ry="75"
      ></ellipse>
      <path
        fill="#495361"
        d="M78.3 76.6s4.1 20.5 20.5 20.5c6.1 0 15.1-5.4 15.1-18.5 0-26.4-36.9-48.9-36.9-48.9S38.4 55 38.4 76.1c0 14.8 6.3 22.7 17.4 22.7 18.8.1 22.5-22.2 22.5-22.2z"
      ></path>
      <path
        fill="#D1423B"
        d="M44.9 47.2l-1.8-4.7h-9.2l-1.7 4.7H26l10-23.8h5.6l9.9 23.8h-6.6zm-6.4-18.6l-3.7 9.9h7.3l-3.6-9.9zm73.2 69.5l1.8 4.7h9.2l1.7-4.7h6.2l-10 23.8H115l-9.9-23.8h6.6zm6.4 18.6l3.7-9.9h-7.3l3.6 9.9z"
      ></path>
      <path fill="#495361" d="M78.3 76.6l-9.4 32.3h19.3z"></path>
    </svg>
  );
};
